var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3733 6.60207C11.3733 7.85697 10.966 9.01617 10.2797 9.95666L13.741 13.4206C14.0827 13.7624 14.0827 14.3173 13.741 14.6591C13.3992 15.0008 12.8442 15.0008 12.5025 14.6591L9.04126 11.1951C8.10077 11.8841 6.94156 12.2887 5.68667 12.2887C2.54533 12.2887 0 9.74341 0 6.60207C0 3.46074 2.54533 0.915405 5.68667 0.915405C8.82801 0.915405 11.3733 3.46074 11.3733 6.60207ZM5.68667 10.539C7.86018 10.539 9.62359 8.77558 9.62359 6.60207C9.62359 4.42856 7.86018 2.66515 5.68667 2.66515C3.51316 2.66515 1.74974 4.42856 1.74974 6.60207C1.74974 8.77558 3.51316 10.539 5.68667 10.539Z",
    fill: "#3F3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconGrey);
export default __webpack_public_path__ + "static/media/search-icon-grey.23b42499f724edacec0c843b0dcbecdd.svg";
export { ForwardRef as ReactComponent };